import type { Product } from '../../catalog/domain-api'
import type { ProductVariant } from '../../catalog/domain-api';

export function buildPosVariantLineProduct(product: Product, variant: ProductVariant): Product {
  const suffix = variant.nameSuffix?.trim();
  const label =
    suffix ||
    Object.entries(variant.attributes ?? {})
      .map(([key, value]) => `${key}: ${value}`)
      .join(' · ');
  return {
    ...product,
    name: label ? `${product.name} — ${label}` : product.name,
    price: variant.price ?? product.price,
    sku: variant.sku ?? product.sku,
    barcode: variant.barcode ?? product.barcode,
    // M3: Use the variant's image if it has one, otherwise fall back to the product image.
    imageUrl: variant.imageUrl ?? product.imageUrl,
  };
}
